import { Card, Stack } from "@mui/material";
import { Icon } from "components/Icon";
import { useTranslation } from "react-i18next";
import { cn } from "utils/styling";

import { scenarioCardWidthClassName } from "../lib/scenarioCardStyles";

type ScenarioAddCardProps = {
  onClick: () => void;
};

export const ScenarioAddCard = ({ onClick }: ScenarioAddCardProps) => {
  const { t } = useTranslation();
  return (
    <Card className={cn(scenarioCardWidthClassName, "")} onClick={onClick}>
      <Stack className="h-full flex-col justify-center gap-3">
        <Icon iconName="Add" size="lg" />
        <p className="font-ds-body-regular-sm text-lds-foreground-muted">{t("TechnicalData.scenario.addScenario")}</p>
      </Stack>
    </Card>
  );
};
